
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon awesome-user-check","d":"M22.4 32A12.8 12.8 0 109.6 19.2 12.81 12.81 0 0022.4 32zm9 3.2h-1.71a17.43 17.43 0 01-14.58 0h-1.67A13.44 13.44 0 000 48.64v4.16a4.79 4.79 0 004.8 4.8H40a4.79 4.79 0 004.8-4.8v-4.16A13.44 13.44 0 0031.37 35.2zm32.26-12.84l-2.79-2.81a1.19 1.19 0 00-1.68 0L48.72 29.94l-4.55-4.58a1.2 1.2 0 00-1.68 0l-2.81 2.79a1.2 1.2 0 000 1.68l8.18 8.23a1.18 1.18 0 001.68 0L63.66 24a1.21 1.21 0 000-1.64z"}})])
          )
        }
      }
    